import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { ItemIcon } from "@similarweb/ui-components";

export const IconType = styled.div`
    position: absolute;
    margin-left: 14px;
    margin-top: 14px;
    border-radius: 50%;
    height: 15px;
    width: 15px;
    border: 1px solid ${colorsPalettes.carbon["100"]};
    background-color: ${colorsPalettes.carbon["0"]};
`;

export const SegmentIcon = styled(SWReactIcons)`
    svg {
        width: 12px;
        height: 12px;
    }
    path {
        fill: ${colorsPalettes.carbon["500"]};
    }
`;

export const StyledItemIcon = styled(ItemIcon)`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-color: #d6dbe1;
    display: flex;
`;
